import { render, staticRenderFns } from "./GetApp.vue?vue&type=template&id=1ea592d0&"
import script from "./GetApp.vue?vue&type=script&lang=ts&"
export * from "./GetApp.vue?vue&type=script&lang=ts&"
import style0 from "./GetApp.vue?vue&type=style&index=0&id=1ea592d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports